import React from 'react';
import { useHistory } from 'react-router-dom';

import Header from '../../components/header';
import Footer from '../../components/footer';
import './styles.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';

export default function A1() {
  const history = useHistory();

  function handleInit(e) {
    e.preventDefault();
    history.push('/options');
  }

  return (
    <>
      <Header content="Suporte Gigage" />
      <div className="support-container container">
        <div className="support-content">
          <div className="row mb-5">
            <p>
              Para fazer a instalação do seu certificado com o auxílio do
              Suporte Gigage você irá precisar de um programa de acesso remoto.
              Esse tipo de programa permite que um dos nossos técnicos acesse o
              seu computador de forma remota e execute o processo de instalação
              diretamente dele. Fique tranquilo! O acesso remoto é um método
              seguro utilizado por várias empresas ao redor do mundo. Caso
              queira fazer o processo sozinho, clique no botão "INICIAR
              TUTORIAL" para seguir o passo-a-passo feito pelos nossos técnicos.
            </p>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <div className="row justify-content-center">
              <a href="http://sigremoto.com/" className="button-support btn" target="_blank" >Suporte Técnico</a>
            </div>
          </div>
          <div className="col-6">
            <div className="row justify-content-center">
              <Link to="/certificates" className="button-support btn">  INICIAR TUTORIAL</Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
